import { DataRow } from '@uni-space/uni-components';

export enum BulkCancelRowStatus {
  /** Посылка найдена и ещё не отменена — кандидат на отмену. */
  Found = 'found',
  AlreadyCanceled = 'alreadyCanceled',
  NotFound = 'notFound',
  /** Отменена в текущей массовой операции. */
  Canceled = 'canceled',
  /** Запрос отмены завершился ошибкой; текст — в errorMessage. */
  Error = 'error',
}

export type BulkCancelRow = DataRow<{
  id: string;
  trackNumber: string;
  status: BulkCancelRowStatus;
  errorMessage?: string;
}>;

/** Задержка перед тем, как кнопка подтверждения массовой отмены станет активной. */
export const BULK_CANCEL_CONFIRM_DELAY_MS = 5000;

/**
 * Разбирает ввод сканера или буфера обмена. Разделители — пробелы и переносы строк
 * (сканер после кода шлёт Enter, поэтому в textarea каждый трек оказывается на своей строке).
 * Пустые токены и повторы отбрасываются, порядок первого появления сохраняется.
 */
export function parseTrackNumbers(raw: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const token of raw.split(/\s+/)) {
    const value = token.trim();
    if (!value || seen.has(value)) continue;
    seen.add(value);
    result.push(value);
  }

  return result;
}

const STATUS_ORDER: Record<BulkCancelRowStatus, number> = {
  [BulkCancelRowStatus.Found]: 0,
  [BulkCancelRowStatus.Canceled]: 1,
  [BulkCancelRowStatus.Error]: 2,
  [BulkCancelRowStatus.AlreadyCanceled]: 3,
  [BulkCancelRowStatus.NotFound]: 4,
};

/** Группирует строки по статусу (сначала те, что можно/удалось отменить), внутри группы порядок ввода. */
export function sortBulkCancelRows(rows: BulkCancelRow[]): BulkCancelRow[] {
  return [...rows].sort((a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status]);
}
